import type { BuiltStage, StageSpec } from './types';
import { buildPad } from './pad';
import { buildRoad, type RoadBuildOptions } from './road';

/** Deterministic, seeded stage builder entry point. */
export function buildStage(spec: StageSpec, opts: RoadBuildOptions = {}): BuiltStage {
  if (spec.kind === 'pad') return buildPad(spec);
  return buildRoad(spec, opts);
}
